/* LIBRAIRIES */
import React from 'react';

/* CONTEXT */
import { useUserContext } from '../../useContext';

/* ICONS */
import { MdDeleteForever } from 'react-icons/md';

/* CSS */
import './DeleteBtn.css';

const DeleteBtn = ({ id }) => {

    const { setOpenModalDeleteUser, setUserId } = useUserContext();

    function handleClick() {
        setOpenModalDeleteUser(true);
        setUserId(id);
    }

    return (
        <button className="delete-button" onClick={() => handleClick()} >
            <MdDeleteForever className='btnDelete'/>
        </button>
    )
}

export default DeleteBtn;